export const peoCharges = {
  administrativeServicekey: [
    {
      question:
        "<strong>Payroll Administration:</strong>Direct Deposit, Payroll Card, and Check Processing Fees.",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Human Resources:</strong> HR Administration & Consulting Services",
      questionId: 3,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Safety and Claims Administration for Workers’ Compensation ",
      questionId: 5,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Employee Benefits:</strong>Administration of Medical, Dental, and Vision Plans; Section 125 (Cafeteria) Plan ",
      questionId: 4,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Year-End W2 Processing Setup Cost (per client)",
      questionId: 1,
      dropDown: "no",
      response: 525,
      calcCharges: "per_client",
    },
    {
      question: "Year-End W2 Processing Cost (per Employee)",
      questionId: 2,
      dropDown: "yes",
      dropDown: "no",
      response: 5.25,
      calcCharges: "per_employee",
    },

    {
      question:
        "<strong>Business Essentials:</strong>Employment Practice Liability Insurance is calculated annually per employee and prorated according to the payroll cycle",
      questionId: 7,
      dropDown: "no",
      response: 156,
      calcCharges: "per_employee",
    },
    {
      question:
        "<strong>Client Company Cyber Insurance:</strong> Annual Cost Per Employee (Pro-rated by Payroll Cycle)",
      questionId: 8,
      dropDown: "no",
      response: 26,
      calcCharges: "per_employee",
    },
  ],

  optionalAdditionalServiceKey: [
    {
      question:
        "<strong>Employee Benefits:</strong>One-time Master 401(K) setup fee per employee, Annual Master 401(K) maintenance per employee, and 401(K) administration.",
      questionId: 1,
      dropDown: "no",
      response: 5455,
      calcCharges: "per_client",
    },
    {
      question:
        "<strong>Business Essentials:</strong>Wage & Hour Endorsement for Employment Practice Liability Insurance (prorated by payroll cycle, $50k policy limit per company, per annum)",
      questionId: 2,
      dropDown: "no",
      response: "Priced on Request",
    },
    {
      question:
        "<strong>Payroll Administration:</strong>GPS-Enabled Smart Timeclock Application for Time and Attendance, Prorated Annually per Employee",
      questionId: 0,
      dropDown: "no",
      response: 90,
      calcCharges: "per_employee",
    },
    {
      question:
        "Annual on-site check printer lease (includes MICR toner, check stock, and envelopes), prorated by payroll cycle.",
      questionId: 3,
      dropDown: "no",
      response: 995,
      calcCharges: "per_client",
    },
    {
      question:
        "<strong>One-Time Purchase: </strong>On-Site Check Printer (includes MICR toner, check stock, and envelopes).",
      questionId: 4,
      dropDown: "no",
      response: 725,
      calcCharges: "per_client",
    },
  ],

  programDetailsAdditionalServiceKey: [
    {
      question:
        "A-rated national insurance carriers with no year-end assessments and contract rates guaranteed annually. Our services include post-accident drug testing, inspections, reporting, data tracking, accident prevention programs, and a back-to-work policy. Additionally, we provide toll-free service for medical care reporting and management.",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Fee for Claim Contribution (per Incident)",
      questionId: 1,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question:
        "<strong>Late Claim Reporting Penalty:</strong> Contribution Fee Increase - For claims reported more than 5 working days after the incident, a penalty will be applied per incident.",
      questionId: 2,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question: "Waiver of subrogation is available for a per waiver fee.",
      questionId: 6,
      dropDown: "no",
      response: 125.0,
    },
    {
      question: "Set Up Fee",
      questionId: 3,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
      calcCharges: "per_client",
    },
    {
      question: "Deposit Fee",
      questionId: 4,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
      calcCharges: "per_client",
    },
    {
      question:
        "Minimum Invoice Charge (program maintenance fee charged per payroll cycle)",
      questionId: 5,
      dropDown: "no",
      response: 0,
    },
  ],
};
export const coastPeoCharges = {
  administrativeServicekey: [
    {
      question:
        "<strong>Payroll Administration:</strong>Direct Deposit, Payroll Card, and Check Processing Fees ",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Human Resources:</strong> HR Administration & Consulting Services",
      questionId: 3,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Safety and Claims Administration for Workers’ Compensation ",
      questionId: 5,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question:
        "<strong>Employee Benefits:</strong>Administration of Medical, Dental, and Vision Plans; Section 125 (Cafeteria) Plan ",
      questionId: 4,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Year-End W2 Processing Setup Cost (per client)",
      questionId: 1,
      dropDown: "no",
      response: 525,
      calcCharges: "per_client",
    },
    {
      question: "Year-End W2 Processing Cost (per Employee)",
      questionId: 2,
      dropDown: "yes",
      dropDown: "no",
      response: 5.25,
      calcCharges: "per_employee",
    },
    {
      question:
        "<strong>Business Essentials:</strong>Employment Practice Liability Insurance is calculated annually per employee and prorated according to the payroll cycle. Please note that there is a state-specific deductible for each claim.",
      questionId: 7,
      dropDown: "no",
      response: 156,
      calcCharges: "per_employee",
    },
    {
      question:
        "<strong>Client Company Cyber Insurance:</strong> Annual Cost Per Employee (Pro-rated by Payroll Cycle)",
      questionId: 8,
      dropDown: "no",
      response: 26,
      calcCharges: "per_employee",
    },
  ],
  optionalAdditionalServiceKey: [
    {
      question:
        "<strong>Employee Benefits:</strong>One-time Master 401(K) setup fee per employee, Annual Master 401(K) maintenance per employee, and 401(K) administration.",
      questionId: 1,
      dropDown: "no",
      response: 5455,
      calcCharges: "per_client",
    },
    {
      question:
        "<strong>Business Essentials:</strong>Wage & Hour Endorsement for Employment Practice Liability Insurance (prorated by payroll cycle, $50k policy limit per company, per annum)",
      questionId: 2,
      dropDown: "no",
      response: "Priced on Request",
    },
    {
      question:
        "<strong>Payroll Administration:</strong>GPS-Enabled Smart Timeclock Application for Time and Attendance, Prorated Annually per Employee",
      questionId: 0,
      dropDown: "no",
      response: 90,
      calcCharges: "per_employee",
    },
    {
      question:
        "Annual on-site check printer lease (includes MICR toner, check stock, and envelopes), prorated by payroll cycle.",
      questionId: 3,
      dropDown: "no",
      response: 995,
      calcCharges: "per_client",
    },
    {
      question:
        "<strong>One-Time Purchase: </strong>On-Site Check Printer (includes MICR toner, check stock, and envelopes).",
      questionId: 4,
      dropDown: "no",
      response: 725,
      calcCharges: "per_client",
    },
  ],

  programDetailsAdditionalServiceKey: [
    {
      question:
        "A-rated national insurance carriers with no year-end assessments and contract rates guaranteed annually. Our services include post-accident drug testing, inspections, reporting, data tracking, accident prevention programs, and a back-to-work policy. Additionally, we provide toll-free service for medical care reporting and management.",
      questionId: 0,
      dropDown: "yes",
      options: ["included", "excluded"],
      response: "included",
    },
    {
      question: "Fee for Claim Contribution (per Incident)",
      questionId: 1,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question:
        "<strong>Late Claim Reporting Penalty:</strong> Contribution Fee Increase - For claims reported more than 5 working days after the incident, a penalty will be applied per incident.",
      questionId: 2,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 2500,
    },
    {
      question:
        "Waiver of subrogation is available for a per waiver fee. Additionally, blanket waivers can be obtained at 2% of the written WC premium.",
      questionId: 6,
      dropDown: "no",
      response: 125.0,
    },
    {
      question: "Set Up Fee",
      questionId: 3,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
      calcCharges: "per_client",
    },
    {
      question: "Deposit Fee",
      questionId: 4,
      dropDown: "yes",
      options: [0, 10, 500, 1250, 2500, 5000, 7500],
      response: 0,
      calcCharges: "per_client",
    },
    {
      question:
        "In the event of any delays or incomplete payroll processing, a prorated minimum weekly charge for WC and Administrative fees will be applied.",
      questionId: 5,
      dropDown: "no",
      response: 0,
    },
  ],
};
